import React, { useMemo } from 'react';
import { LuCheck, LuChevronDown, LuTags } from 'react-icons/lu';
import Button from '../../ui/Button';
import DropdownMenu from '../../ui/DropdownMenu';
import { topicCounts } from './postList.js';
import { plural } from '../../../utils/text.js';

const NoIcon = ({ className }) => <span className={className} />;

const TopicFilter = ({ posts, value, onChange }) => {
  const counts = useMemo(() => topicCounts(posts), [posts]);
  if (!counts.length) return null;
  const items = [
    { id: 'all', label: 'Tous les topics', icon: value ? NoIcon : LuCheck, onClick: () => onChange(null) },
    { divider: true },
    ...counts.map(([code, n]) => ({
      id: code,
      label: <><span className="font-mono">{code}</span> · {plural(n, 'post')}</>,
      icon: value === code ? LuCheck : NoIcon,
      onClick: () => onChange(code),
    })),
  ];
  return (
    <DropdownMenu
      items={items}
      label="Filtrer par topic"
      align="left"
      width="w-80 max-h-80 overflow-y-auto"
      trigger={({ open, toggle, ref, ...aria }) => (
        <Button ref={ref} onClick={toggle} {...aria} variant={value ? 'soft' : 'secondary'} icon={LuTags} iconRight={LuChevronDown}>
          {value ? <span className="font-mono">{value}</span> : 'Tous les topics'}
        </Button>
      )}
    />
  );
};

export default TopicFilter;
